import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";

const useImportUsers = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();

	const history = useHistory();

	const importUsers = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");

		const body = deleteEmptyObjects(obj);

		const formData = new FormData();
		Object.keys(body).forEach((key) => {
			formData.append(key, body[key]);
		});

		await queryClient.invalidateQueries("users");

		const response = await instance.post("/users/import", formData, {
			responseType: "blob", // Important for file downloads
		});

		// Create a blob URL for the downloaded file
		const blob = new Blob([response.data], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		const url = window.URL.createObjectURL(blob);

		// Get filename from Content-Disposition header or use default
		let filename = "users_import_result.xlsx";
		const contentDisposition = response.headers["content-disposition"];
		if (contentDisposition) {
			const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
			if (filenameMatch) {
				filename = filenameMatch[1];
			}
		}

		queryClient.invalidateQueries("users");

		// Return the download URL and filename
		return { downloadUrl: url, filename };
	};

	return useMutation(importUsers, {
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useImportUsers;
